import { styled } from "styled-components";

export const SliderContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 48px;
  width: 100%;
  position: relative;

  ${({ theme }) => theme.breakpoints.md.query} {
    flex-direction: column;
    align-items: center;
  }
`;
